import { createApi } from 'api/common/createApi'
import config, { API_TYPES } from 'constants/api-config'

export const briefApi = createApi({
  baseURL: config[API_TYPES.BRIEF_API_URL],
})

export const mtApi = createApi({
  baseURL: config[API_TYPES.MT_API_URL],
})
